import "./EditableBusinessIdea.css"
import { useState } from "react";
import Popup from "reactjs-popup";
import EditIcon from '@mui/icons-material/Edit';
import UpdateBusinessIdea from "./package/UpdateBusinessIdea";
import CreateBusinessIdea from "./package/CreateBusinessIdea";
import DeleteBusinessIdea from "./package/DeleteBusinessIdea";

const EditableBusinessIdea = ({ id, PopupTitle, businessName, businessDescription, isActionCreate }) => {
    const [name, setName] = useState(businessName ?? "");
    const [description, setDescription] = useState(businessDescription ?? "");
    const [profilePic, setProfilePic] = useState(null);
    const [btnLoading, setBtnLoading] = useState(false);
    const [deleteBtnLoading, setDeleteBtnLoading] = useState(false);

    function refreshPage() {
        window.location.reload();
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isActionCreate) {
            let success = await CreateBusinessIdea({
                title: name,
                description,
                editionId: id,
                btnLoading,
                setBtnLoading,
                profilePic
            });
            if (success) {
                refreshPage();
            }
        } else {
            let success = await UpdateBusinessIdea({
                businessId: id,
                title: name,
                description: description,
                btnLoading: btnLoading,
                setBtnLoading: setBtnLoading,
                profilePic: profilePic,
            });
            if (success) {
                refreshPage();
            }
        }
    };

    const handleDeleteProfile = async (e) => {
        e.preventDefault();
        let success = await DeleteBusinessIdea({
            btnLoading: deleteBtnLoading,
            setBtnLoading: setDeleteBtnLoading,
            id: id ?? "",
        });
        if (success) {
            refreshPage();
        }
    };

    return (
        <Popup
            trigger={
                PopupTitle ?
                    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                        <div className="primary_btn"
                            style={{
                                fontSize: "1.2rem",
                                margin: "0",
                                width: "25rem",
                                textAlign: "center"
                            }}  >
                            {PopupTitle}
                        </div>
                    </div>
                    : <div className="dt_trigger_btn">
                        <div className="dt_edit_btn" style={{ marginRight: "0.5rem" }} >
                            <EditIcon />
                        </div>
                    </div>
            }
            modal
        >
            {(close) => {
                return (
                    <div className="ehp_edit_popup">
                        <div className="ehp_inner_container"
                            style={{
                                height: "65vh",
                            }} >
                            <form className="ehp_form_container" onSubmit={handleSubmit}>
                                <h1 className="ehp_form_container_header"  >
                                    {PopupTitle ?? "Edit Speaker"}
                                </h1>
                                <div className="ehp_form_top">
                                    <div className="ehp_form_left">
                                        <label htmlFor="name" className="ehp_label pe_bi_intput_field">
                                            Title:
                                        </label>
                                        <input
                                            id="name"
                                            value={name}
                                            type="text"
                                            onChange={(e) => {
                                                setName(e.target.value);
                                            }}
                                            className="ehp_input_field pe_bi_intput_field"
                                            placeholder=""
                                            required
                                        />
                                        <label htmlFor="profilePic" className="ehp_label pe_bi_intput_field">
                                            New Profile Picture:
                                        </label>
                                        {
                                            isActionCreate ?
                                                <input type="file" name="file" id="profilePic"
                                                    accept="image/*"
                                                    required
                                                    className="ehp_file_input dt_pp_input pe_bi_intput_field"
                                                    onChange={(event) => {
                                                        setProfilePic(event.target.files[0]);
                                                    }}
                                                /> :
                                                <input type="file" name="file" id="profilePic"
                                                    accept="image/*"
                                                    className="ehp_file_input dt_pp_input pe_bi_intput_field"
                                                    onChange={(event) => {
                                                        setProfilePic(event.target.files[0]);
                                                    }}
                                                />
                                        }
                                    </div>
                                    <div className="ehp_form_right">
                                        <label htmlFor="position" className="ehp_label">
                                            Description:
                                        </label>
                                        <textarea
                                            id="position"
                                            value={description}
                                            onChange={(e) => {
                                                setDescription(e.target.value);
                                            }}
                                            style={{
                                                height: "20rem",
                                            }}
                                            className="ehp_input_field"
                                            placeholder=""
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="ehp_form_bottom">
                                    <input
                                        type="submit"
                                        className="ehp_submit primary_btn"
                                        value={btnLoading ? "Loading..." : "Submit"}
                                    />
                                    {
                                        isActionCreate ? "" :
                                            <input
                                                type="button"
                                                onClick={handleDeleteProfile}
                                                className="ehp_cancel primary_btn"
                                                value={deleteBtnLoading ? "Loading..." : "Delete"}
                                            />
                                    }
                                    <input
                                        type="button"
                                        className="ehp_cancel primary_btn "
                                        onClick={() => {
                                            close();
                                        }}
                                        value={"Cancel"}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                );
            }}
        </Popup >
    );
};

export default EditableBusinessIdea;